import { appProfileDaysG4De } from './golf4App.de.js';
// Duits (de-DE), "Was zu unserer Familie passt": zelfde vorm als profileApp.nl.ts. Zelfde toon als
// nl: gewoontes, nooit nationaliteit of afkomst; een voorstel vraagt. AVG heet in het Duits DSGVO.
//
// LET OP: consent.text/check en selfConsent.text/check zijn hier vertaald, maar alleen de nl- en
// en-teksten zitten in CONSENT_TEXT_HASHES (packages/domain/src/profile/vocab.ts). Zet een ouder de
// app in het Duits, dan leest hij deze tekst; de oprichter beslist of de-tekst in de hash komt.
// `consent.version` blijft gelijk aan PROFILE_CONSENT_VERSION (de app stuurt die constante zelf).
export const appProfileDe = {
    title: 'Was zu unserer Familie passt',
    intro: 'Wähle, was zu euch passt. Dann wird es in den Listen ruhiger. Alles ist freiwillig.',
    privacyLine: 'Nur Eltern können das sehen und ändern. Verbundene Verwandte sehen es nie.',
    privacyLink: 'Datenschutzerklärung',
    privacyPage: {
        title: 'Datenschutzerklärung',
        back: 'Zurück zur App',
        intro: 'Über „Was zu unserer Familie passt“: Küche, Glaube, Essen und besondere Tage. Kurz und klar.',
        sections: [
            {
                title: 'Wofür',
                body: 'Wir nutzen eure Auswahl nur, um zu entscheiden, welche Optionen du siehst: Vorlagen, Piktogramme, Rezepte und besondere Tage. Nicht für Werbung, nicht für Profile über euch und nicht zum Weitergeben.',
            },
            {
                title: 'Welche Daten',
                body: 'Küchen und Traditionen, Glaube (mit den gewählten Gewohnheiten und der Rechtsschule), Essensregeln (wie halal oder vegetarisch), Abweichungen pro Familienmitglied, „isst etwas anderes“ bei einem Rezept und die besonderen Tage, die du eingeschaltet hast. Glaube, halal und koscher, und manchmal eine Tradition, sind besondere Kategorien personenbezogener Daten (Art. 9 DSGVO).',
            },
            {
                title: 'Rechtsgrundlage',
                body: 'Deine ausdrückliche Einwilligung (Art. 9 Abs. 2 lit. a DSGVO). Ein Elternteil gibt sie für sich selbst und für die Kinder unter 16; ein Erwachsener mit eigenem Login kann selbst für eine eigene Abweichung einwilligen. Alles ist freiwillig: Ohne Einwilligung funktioniert die App ganz normal.',
            },
            {
                title: 'Wer es sieht',
                body: 'Nur die Eltern in eurer Familie sehen die Auswahl selbst. Das Tablet und die App zeigen nur, was dazu passt; beim Essen nennen wir, wer etwas nicht isst. Verbundene Verwandte, Gäste, geteilte Links, Kalender-Feeds, Fehlermeldungen und Logdateien bekommen die Auswahl nie. Besondere Tage kommen nur in einen Kalender-Export, wenn du das extra einschaltest.',
            },
            {
                title: 'Wie lange',
                body: 'Solange die Einwilligung gilt. Ein Widerruf löscht die Auswahl sofort; aus Back-ups verschwindet sie innerhalb von 90 Tagen. Den Nachweis der Einwilligung selbst (wer, wann, welcher Text, ohne Inhalt) bewahren wir bis 5 Jahre nach dem Widerruf auf oder bis die Familie gelöscht wird.',
            },
            {
                title: 'Deine Rechte',
                body: 'Du kannst deine Daten unter Einstellungen · Was zu unserer Familie passt einsehen und ändern, sie unter Einstellungen · Daten herunterladen herunterladen (jeder Elternteil seine eigenen Daten, der Verwalter alles), deine Einwilligung widerrufen (das löscht alles) und die Löschung verlangen. Bist du mit etwas nicht einverstanden, kannst du dich bei der niederländischen Datenschutzbehörde (Autoriteit Persoonsgegevens) beschweren.',
            },
            {
                title: 'Verantwortlicher und Kontakt',
                body: 'AMUMIN B.V. ist für diese Daten verantwortlich. Deine eigenen Daten lädst du selbst unter Einstellungen herunter. Für Fragen oder eine Löschung wendest du dich an AMUMIN B.V.; solange die feste Datenschutzadresse unten noch fehlt, über den Verwalter eures Familienkontos. Eine feste Datenschutzadresse und die Angaben aus dem Handelsregister (KvK) stehen hier, bevor sich andere Familien anmelden können.',
            },
        ],
    },
    settingsBody: 'Küche, Glaube, Essen und besondere Tage',
    saveBar: 'Änderungen speichern',
    invite: {
        title: 'Was passt zu eurer Familie?',
        body: 'Wähle Küche, Glaube und Essen, dann siehst du vor allem, was zu euch passt. Das ist freiwillig.',
        start: 'Einrichten',
        later: 'Nicht jetzt',
        never: 'Nein, danke',
    },
    otherParent: {
        title: 'Was zu eurer Familie passt',
        body: '{name} hat eingestellt, was zu eurer Familie passt: {what}. Stimmt das auch für dich?',
        titleNeutral: 'Was zu euch passt',
        bodyNeutral: '{name} hat eingestellt, was zu euch passt: {what}. Stimmt das auch für dich?',
        view: 'Ansehen',
    },
    wizard: {
        title: 'Was passt zu euch?',
        body: 'Wähle nur, was du willst; der Rest darf leer bleiben. Du kannst alles später ändern.',
        skip: 'Überspringen',
        skipQuestion: 'Diese Frage überspringen',
        next: 'Weiter',
        done: 'Fertig',
        save: 'Speichern',
        nothingSaved: 'Du hast nichts gewählt, also speichern wir nichts.',
        step: '{n} von {total}',
        question: '{step} · Frage {n} von {total}',
    },
    traditions: {
        title: 'Küche und Traditionen',
        body: 'Welche Küchen und Traditionen gehören zu euch? Wähle ruhig mehrere.',
        hint: 'Es geht um Gewohnheiten, nicht um Nationalität. Wir merken uns nur, welche Küchen ihr gern esst. Wir nutzen das für die Reihenfolge der Rezepte und um Feiertage vorzuschlagen.',
        labels: {
            dutch: 'Niederländisch',
            turkish: 'Türkisch',
            moroccan: 'Marokkanisch',
            surinamese: 'Surinamisch',
            antillean: 'Antillianisch',
            indonesian: 'Indonesisch',
            moluccan: 'Molukkisch',
            italian: 'Italienisch',
            polish: 'Polnisch',
            middle_eastern: 'Nahöstlich',
            other: 'Andere',
        },
        otherKitchens: {
            title: 'Welche Küchen esst ihr gern?',
            more: 'Mehr Küchen',
        },
    },
    suggestion: {
        title: 'Passt das zu euch?',
        body: 'Du entscheidest selbst. Du kannst es jederzeit ändern.',
        accept: 'Ja, übernehmen',
        decline: 'Selbst wählen',
        days: 'Es gibt auch {sets} zum Hinzufügen. Die schaltest du selbst bei Besondere Tage ein.',
    },
    faiths: {
        title: 'Glaube',
        body: 'Dann siehst du die passenden Optionen. Feiertage kannst du danach selbst einschalten.',
        none: 'Kein Glaube',
        shows: 'Du siehst dann {list}',
        /** Golf 6b: gewoontes bij het gekozen geloof, optioneel (niets voorgevinkt). */
        madhab: {
            title: 'Welcher Rechtsschule (Madhhab) folgt ihr?',
            body: 'Damit stellen wir unter anderem die Zeit für Asr (İkindi) richtig ein. Ihr könnt das jederzeit ändern.',
            hint: 'Türkische Moscheen, etwa von Diyanet (DITIB) und Milli Görüş, folgen der hanafitischen Schule. Marokkanische Moscheen meist der malikitischen.',
            unknown: 'Weiß ich nicht / überspringen',
            labels: { hanafi: 'Hanafi', shafii: 'Schafiʿi', maliki: 'Maliki', hanbali: 'Hanbali' },
        },
        practicesTitle: 'Was gehört bei euch dazu?',
        practicesHint: 'Kreuzt an, was ihr macht. Nur das legen wir als Termin, Aufgabe oder Bildsymbol bereit. Nichts ankreuzen geht auch.',
        openHint: 'Wählst du nichts, stehen Beten und Moscheeunterricht nicht bei den Vorschlägen (die Suche findet sie trotzdem). Wähle euren Glauben, wenn ihr sie sehen wollt.',
        labels: {
            islam: 'Islam',
            christianity: 'Christentum',
            judaism: 'Judentum',
            hinduism: 'Hinduismus',
            other: 'Ein anderer Glaube',
        },
    },
    food: {
        title: 'Essen',
        body: 'Rezepte und Einkäufe, die nicht dazu passen, blenden wir aus. Du findest sie immer über die Suche oder „Alle zeigen“.',
        labels: {
            halal: 'Halal',
            no_pork: 'Kein Schweinefleisch',
            no_beef: 'Kein Rindfleisch',
            vegetarian: 'Vegetarisch',
            vegan: 'Vegan',
            kosher: 'Koscher',
            no_alcohol: 'Kein Alkohol',
        },
    },
    days: {
        ...appProfileDaysG4De,
        title: 'Besondere Tage im Kalender',
        optional: 'freiwillig',
        body: 'Möchtest du zusätzliche Tage im Kalender? Die niederländischen Feiertage sind an; die zusätzlichen Sets sind alle aus. Schalte ein, was du sehen willst.',
        perDay: 'Pro Tag wählen',
        more: 'Mehr besondere Tage',
        next: 'Als Nächstes: {dates}',
        noDates: 'Die Daten für dieses Jahr folgen noch.',
        expected: '(erwartet)',
        expectedNote: 'Der genaue Tag kann sich um einen Tag verschieben.',
        expectedTag: 'erwartet',
        sheet: {
            expected: 'Dieser Tag steht noch nicht fest.',
            when: 'Fällt auf {dates}.',
            confirm: 'Tag bestätigen',
            confirmHint: 'Bestätige oder verschiebe ihn unter Was zu unserer Familie passt, Besondere Tage.',
        },
        eveBefore: 'Beginnt am Vorabend bei Sonnenuntergang.',
        eitherOr: '{a} oder {b}',
        nl: {
            title: 'Niederländische Feiertage',
            note: 'Für alle. Standardmäßig an.',
            days: {
                nieuwjaarsdag: 'Neujahr',
                goede_vrijdag: 'Karfreitag',
                pasen: 'Ostern',
                koningsdag: 'Koningsdag',
                bevrijdingsdag: 'Befreiungstag',
                hemelvaartsdag: 'Christi Himmelfahrt',
                pinksteren: 'Pfingsten',
                kerstmis: 'Weihnachten',
                moederdag: 'Muttertag',
                vaderdag: 'Vatertag',
                sinterklaas: 'Sinterklaas',
                oudejaarsavond: 'Silvester',
            },
        },
        dayNames: {
            ramadan_start: 'Beginn des Ramadan',
            ramadan_end: 'Letzter Tag des Ramadan',
            eid_al_fitr: 'Eid al-Fitr (Zuckerfest)',
            eid_al_adha: 'Eid al-Adha (Opferfest)',
            islamic_new_year: 'Islamisches Neujahr',
            mawlid: 'Mawlid (Mevlid)',
        },
        tradition: {
            title: 'Welchem Kalender folgt ihr?',
            body: 'Nicht alle Moscheen legen die Feiertage auf dieselbe Weise fest.',
            options: {
                diyanet: 'Türkisch (Diyanet, fester Kalender)',
                saudi: 'Saudi-Arabien (Mondsichtung)',
                morocco: 'Marokko (Mondsichtung, Bestätigung am Vorabend)',
                own_mosque: 'Eigene Moschee (±1 Tag)',
            },
            hints: {
                diyanet: 'Die Daten stehen Jahre im Voraus fest.',
                saudi: 'Bis zur Ankündigung am Vorabend siehst du zwei mögliche Tage.',
                morocco: 'Fällt oft einen Tag später als in Saudi-Arabien. Bis zur Ankündigung siehst du zwei mögliche Tage.',
                own_mosque: 'Du siehst den festen Kalender. Wählt eure Moschee einen Tag früher oder später, stell es hier richtig ein.',
            },
            defaultNote: 'Standardmäßig der feste Kalender von Diyanet. Wählt gern, was eure Moschee nutzt.',
            confirmTitle: 'Schon bekannt?',
            confirmBody: 'Tippe auf den Tag, den eure Moschee gewählt hat. Dann steht er fest im Kalender.',
            unknown: 'Noch unbekannt',
            confirmedNote: 'Fest im Kalender.',
        },
        sets: {
            tr_national: 'Türkische Feiertage',
            keti_koti: 'Keti Koti',
            indies_remembrance: 'Gedenken 15. August',
            id_independence: 'Unabhängigkeitstag Indonesiens',
            it_national: 'Italienische Feiertage',
            pl_national: 'Polnische Feiertage',
            islamic: 'Islamische Feiertage',
            christian: 'Christliche Tage',
            jewish: 'Jüdische Feiertage',
            hindu: 'Hinduistische Feiertage',
        },
        ics: {
            toggle: 'Besondere Tage auch in Kalender-Exporten',
            warning: 'Deine Kalender-App (zum Beispiel Google) sieht dann diese Tage.',
        },
    },
    flags: {
        pork: 'Schweinefleisch',
        beef: 'Rindfleisch',
        meat: 'Fleisch',
        fish: 'Fisch',
        shellfish: 'Schalen- und Krustentiere',
        dairy: 'Milchprodukte',
        egg: 'Ei',
        honey: 'Honig',
        gelatin: 'Gelatine',
        alcohol: 'Alkohol',
    },
    kitchens: {
        dutch: 'Holländisch',
        turkish: 'Türkisch',
        moroccan: 'Marokkanisch',
        surinamese: 'Surinamisch',
        antillean: 'Antillianisch',
        indonesian: 'Indonesisch',
        moluccan: 'Molukkisch',
        italian: 'Italienisch',
        polish: 'Polnisch',
        middle_eastern: 'Nahöstlich',
        chinese: 'Chinesisch',
        indian: 'Indisch',
        mexican: 'Mexikanisch',
        greek: 'Griechisch',
        west_african: 'Westafrikanisch',
        central_african: 'Zentralafrikanisch',
        east_african: 'Ostafrikanisch',
        american: 'Amerikanisch',
    },
    member: {
        follows: 'Wie die Familie',
        differs: 'Anders als die Familie',
        reset: 'Wieder der Familie folgen',
        plus: 'Wie die Familie, plus {what}',
        minus: 'Wie die Familie, ohne {what}',
        faithDiffers: 'Glaube: {what}',
        notPossible: 'Für {name} kannst du das nicht einzeln einstellen. Das geht nur, wenn {name} selbst mit einem eigenen Login einwilligt. Bis dahin folgt {name} der Familie.',
        askSelf: 'Bitte {name}, das selbst einzustellen.',
        shareLink: 'Link teilen',
    },
    consent: {
        version: '2026-09-25.4',
        title: 'Ist das in Ordnung?',
        text: 'Glaube, Essensregeln und Küchen können sensible Daten sein. Wir nutzen sie nur, um zu entscheiden, welche Optionen du siehst.\nNur Eltern können das sehen und ändern. Das Tablet und die App zeigen, was dazu passt; beim Essen nennen wir, wer etwas nicht isst.\nBei manchen Auswahlen kannst du zusätzliche Bereiche auf das Board bringen. Alle im Raum sehen sie dann.\nWir teilen nichts mit verbundenen Verwandten oder in geteilten Listen. Besondere Tage kommen nur in den Kalender oder in einen Kalender-Export, wenn du das selbst einschaltest.\nDu kannst jederzeit widerrufen, und es wird sofort gelöscht. Aus Back-ups verschwindet es innerhalb von 90 Tagen.\nAMUMIN B.V. ist für diese Daten verantwortlich. Deine Rechte stehen in der Datenschutzerklärung.',
        check: 'Ich willige für mich selbst und für meine Kinder unter 16 ein.',
        given: 'Einwilligung von {name} am {date}',
        /** Fijnslijpen: zonder bekende naam (geen "door  op"). */
        givenAt: 'Einwilligung erteilt am {date}',
        renew: 'Die Erklärung hat sich geändert. Lies sie kurz und willige erneut ein.',
        withdraw: 'Einwilligung widerrufen und löschen',
        withdrawConfirm: 'Wir löschen Küchen, Glaube, Essensregeln und besondere Tage eurer Familie. Danach siehst du wieder alles. Weiter?',
        withdrawn: 'Gelöscht. Du siehst wieder alles.',
    },
    selfConsent: {
        title: 'Stimmt das für dich?',
        text: 'Du stellst für dich selbst ein, was du glaubst oder isst. Wir nutzen es nur, um zu entscheiden, welche Optionen du siehst, und beim Essen nennen wir deinen Namen, wenn etwas nicht zu dir passt. Nur du und die Eltern in dieser Familie sehen es. Ein Widerruf löscht es sofort.',
        check: 'Ich willige für mich selbst ein.',
        withdraw: 'Meine Einwilligung widerrufen',
    },
    daySetsInline: {
        tr_national: 'türkische Feiertage',
        keti_koti: 'Keti Koti',
        indies_remembrance: 'das Gedenken am 15. August',
        id_independence: 'den Unabhängigkeitstag Indonesiens',
        it_national: 'italienische Feiertage',
        pl_national: 'polnische Feiertage',
        islamic: 'islamische Feiertage',
        christian: 'christliche Tage',
        jewish: 'jüdische Feiertage',
        hindu: 'hinduistische Feiertage',
    },
    hidden: {
        showAll: 'Alle zeigen',
        showLess: 'Weniger zeigen',
        count: { one: '{count} Option ausgeblendet', other: '{count} Optionen ausgeblendet' },
        groupFood: 'Ausgeblendet, weil ihr {rules}',
        groupFaith: 'Gehört zu einem anderen Glauben',
        groupNotChosen: 'Erscheint, wenn du {what} wählst',
        groupFaithOpen: 'Ausgeblendet, bis ihr bei Glaube etwas wählt',
        /** Golf 6b: geloof gekozen, gewoonte niet aangevinkt. */
        groupPractice: 'Bei Glaube nicht angekreuzt',
        practice: 'Ausgeblendet, weil ihr {practice} bei Glaube nicht angekreuzt habt. Ändern in den Einstellungen.',
        change: 'Ändern',
        faith: 'Gehört zu {faiths}. Ihr habt etwas anderes gewählt.',
        faithNone: 'Ausgeblendet, weil ihr bei Glaube „Kein Glaube“ gewählt habt. Ändern in den Einstellungen.',
        notChosen: 'Erscheint, wenn du {what} in den Einstellungen wählst.',
        faithOpen: 'Ausgeblendet, bis ihr bei Glaube etwas wählt. Ändern in den Einstellungen.',
        food: 'Ausgeblendet, weil ihr {rules}. Ändern in den Einstellungen.',
        variant: 'Eine Variante dieses Rezepts steht schon in der Liste.',
        rulePhrase: {
            halal: 'halal esst',
            no_pork: 'kein Schweinefleisch esst',
            no_beef: 'kein Rindfleisch esst',
            vegetarian: 'vegetarisch esst',
            vegan: 'vegan esst',
            kosher: 'koscher esst',
            no_alcohol: 'keinen Alkohol trinkt',
        },
    },
    warning: {
        contains: 'Hier ist {ingredient} drin.',
        containsMany: 'Hier sind {ingredient} drin.',
        person: {
            halal: '{names} isst halal.',
            no_pork: '{names} isst kein Schweinefleisch.',
            no_beef: '{names} isst kein Rindfleisch.',
            vegetarian: '{names} isst vegetarisch.',
            vegan: '{names} isst vegan.',
            kosher: '{names} isst koscher.',
            no_alcohol: '{names} trinkt keinen Alkohol.',
        },
        people: {
            halal: '{names} essen halal.',
            no_pork: '{names} essen kein Schweinefleisch.',
            no_beef: '{names} essen kein Rindfleisch.',
            vegetarian: '{names} essen vegetarisch.',
            vegan: '{names} essen vegan.',
            kosher: '{names} essen koscher.',
            no_alcohol: '{names} trinken keinen Alkohol.',
        },
        everyone: {
            halal: 'Ihr esst halal.',
            no_pork: 'Ihr esst kein Schweinefleisch.',
            no_beef: 'Ihr esst kein Rindfleisch.',
            vegetarian: 'Ihr esst vegetarisch.',
            vegan: 'Ihr esst vegan.',
            kosher: 'Ihr esst koscher.',
            no_alcohol: 'Ihr trinkt keinen Alkohol.',
        },
        check: 'Achtung: Hier ist vielleicht {what} drin.',
        meatDairy: 'Hier ist Fleisch mit Milchprodukten drin: {meat} und {dairy}.',
        item: {
            pork: 'Hier ist Schweinefleisch drin.',
            beef: 'Hier ist Rindfleisch drin.',
            meat: 'Hier ist Fleisch drin.',
            fish: 'Hier ist Fisch drin.',
            shellfish: 'Hier sind Schalen- oder Krustentiere drin.',
            dairy: 'Hier sind Milchprodukte drin.',
            egg: 'Hier ist Ei drin.',
            honey: 'Hier ist Honig drin.',
            gelatin: 'Hier ist meistens Schweinegelatine drin.',
            alcohol: 'Hier ist Alkohol drin.',
        },
        swap: 'Tipp: {swap} statt {ingredient}.',
        swapButton: 'Tauschen',
        addAnyway: 'So lassen',
        add: 'Okay',
        eatsOther: '{name} isst etwas anderes',
        whoEats: 'Wer isst mit?',
        everyoneEats: 'Alle',
        and: 'und',
    },
    screens: {
        practices: {
            prayer: 'Beten',
            wudu: 'Wudu machen',
            mosque: 'Moschee(unterricht)',
            quran: 'Koranunterricht',
            church: 'Kirche',
            shabbat: 'Schabbat',
            synagogue: 'Synagoge',
            mandir: 'Mandir',
        },
        noneHint: 'Dann blenden wir Glaubensoptionen wie Beten und Moscheeunterricht aus.',
        otherFaithHint: 'Beten bleibt sichtbar; die Optionen der genannten Religionen nicht.',
        stepLabel: 'Schritt {n} von {total}',
        progress: 'Frage {n} von {total}',
        noConsentYet: 'Ohne Einwilligung speichern wir nichts.',
        saved: 'Gespeichert. Du siehst vor allem, was zu euch passt.',
        savedMember: 'Gespeichert für {name}.',
        resetMember: '{name} folgt wieder der Familie.',
        savedSelf: 'Gespeichert.',
        resetSelf: 'Du folgst wieder der Familie.',
        selfWithdrawn: 'Deine eigene Auswahl wurde gelöscht.',
        noChanges: 'Es hat sich nichts geändert.',
        loadError: 'Das konnte nicht geladen werden.',
        changed: 'Du hast etwas geändert.',
        settingsCardBody: 'Küche, Glaube, Essen und besondere Tage',
        membersTitle: 'Pro Familienmitglied',
        membersIntro: 'Die Familie ist der Standard. Ein Familienmitglied kann abweichen.',
        consentTitle: 'Einwilligung',
        appliesTo: 'Gilt für: {list}',
        selfTag: '{name} (selbst)',
        kidsTag: '{list} (Kinder unter 16)',
        noConsent: 'Es wurde noch keine Einwilligung gegeben. Wir fragen danach beim ersten Speichern.',
        inviteLater: 'Wir fragen später noch einmal.',
        inviteNever: 'In Ordnung. Du findest es jederzeit in den Einstellungen.',
        otherParentWhat: 'Küche, Glaube und Essen',
        dayCount: 'Tag {n} von {total}',
        daysOn: 'An',
        daysOff: 'Aus',
        lessDays: 'Weniger besondere Tage',
        offeredEmpty: 'Wähle oben Küche oder Glaube, dann schlagen wir passende Tage vor.',
        member: {
            title: 'Anpassen',
            open: 'Anpassen für {name}',
            faith: 'Glaube',
            food: 'Essen',
            foodHint: 'Die Auswahl der Familie ist angehakt. Was du einschaltest, kommt dazu; was du ausschaltest, gilt nicht für {name}. Spätere Änderungen der Familie gelten automatisch mit.',
            faithFollows: 'Glaube: wie die Familie',
            lapsed: '{name} stellt das jetzt selbst ein.',
            selfIntro: 'Du stellst das für dich selbst ein.',
            selfGiven: 'Du hast für dich selbst eingewilligt.',
            withdrawSelfTitle: 'Deine eigene Auswahl löschen?',
            withdrawSelfBody: 'Du folgst dann wieder der Familie. Was du für dich eingestellt hast, löschen wir sofort.',
            withdrawSelfConfirm: 'Löschen',
            save: 'Speichern',
            linkCopied: 'Link kopiert.',
            notSetYet: 'Stell zuerst ein, was zur Familie passt, und speichere es. Danach kannst du pro Familienmitglied abweichen.',
        },
        self: {
            title: 'Was zu mir passt',
            intro: 'Glaubst oder isst du anders als die Familie? Das stellst du hier selbst ein. Nur du und deine Eltern sehen es.',
            parents: 'Das stellen deine Eltern ein. Ab 16 kannst du hier selbst angeben, was für dich anders ist.',
            notYet: 'Deine Eltern haben noch nicht eingestellt, was zu eurer Familie passt. Danach kannst du hier deine eigene Auswahl treffen.',
            settingsBody: 'Dein eigener Glaube und dein Essen',
        },
    },
};
//# sourceMappingURL=profileApp.de.js.map